interface selectInterface {
  name: string
  value: number
}

export const useToProvinces = () => {
  const fromRegister = (
    params: { id: number; name: string; slug: string }[],
  ) => {
    let items: selectInterface[] = []
    items = params.map(item => {
      return {
        name: item.name,
        value: item.id,
      }
    })

    return items
  }

  return { fromRegister }
}
